import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function BtnPreviousPath() {
    const navigate = useNavigate();
   
    return (
        <div>
            <button type="button" className="btn btn-primary"
                onClick={goToPreviousPath} style={{ width: "10rem" }}>
                <FontAwesomeIcon icon={['fas', 'chevron-left']} size={'2x'} color={'white'} />
                <span style={{margin: "8px", verticalAlign: "super"}}>Indietro</span>
            </button>
        </div>
    )

    function goToPreviousPath() {
        navigate(-1);
    }
}